var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-empty-function */
import { useParams } from 'react-router-dom';
import { Error } from 'components/Error';
import { useAlert } from 'components/alert/AlertStack';
import { pushEnhancedConversionUserData } from 'components/domain/gtmConsent';
import { classNames, createContext, useContext, useEffect, useMutation, useRef } from 'libs/react';
import { useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { QuoteApproval } from './QuoteApproval';
import { QuoteBanner } from './QuoteBanner';
import { QuoteClient } from './QuoteClient';
import { QuoteContact } from './QuoteContact';
import { QuoteHeader } from './QuoteHeader';
import { QuoteSummary } from './QuoteSummary';
import { QuoteSummaryPanel } from './QuoteSummaryPanel';
import { Content } from 'components/Content';
import { Header } from 'components/Header';
import { Screen } from 'components/Screen';
import { DealPublicQuery } from 'graphql/Deal/queries/DealPublicQuery';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { Sidebar } from 'components/Sidebar';
import { DealSidebar } from 'modules/deal/components/DealSidebar';
import { v4 as uuidv4 } from 'uuid';
import { getRelations } from 'helpers/Deal';
import { useModal } from 'components/modal/ModalStack';
import { DealItemPickerOptionAlert } from 'modules/deal/components/picker/DealItemPickerOptionAlert';
import { calculatePriceCurrency, getDiscountRep } from 'helpers/Pricing';
import { UpdateDealPublicMutation } from 'graphql/Deal/mutations/UpdateDealPublicMutation';
import { FieldGroupsQuery } from 'graphql/FieldGroup/queries/FieldGroupsQuery';
import i18n from 'components/translation/i18n';
import { ModalValidityPeriod } from './modal/ModalValidityPeriod';
import { QuoteHeaderInfo } from './QuoteHeaderInfo';
import { useDomain } from 'components/domain/DomainProvider';
import { QuoteField } from './QuoteField';
import { QuoteNotes } from './QuoteNotes';
import { MutationForm } from 'components/form/graphql/MutationForm';
import { ApproveDealMutation } from 'graphql/Deal/mutations/ApproveDeal';
import { ModalIdentityVerification } from './modal/ModalIdentityVerification';
import { ModalPaymentSuccess } from './modal/ModalPaymentSuccess';
import { LogOpeningDealMutation } from 'graphql/Deal/mutations/LogOpeningDealMutation';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { recalculateOtherFeesPrices } from 'helpers/otherFeesCalculation';
import './QuoteScreen.scss';
import { QuoteSummaryBundled } from './QuoteSummaryBundled';
import { applyBrandColors, resolvePrimaryColor } from 'helpers/primaryColor';
/**
 * @component QuoteScreen
 * @since 1.0.0
 */
export function QuoteScreen(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
    const { style } = Object.assign({ style: 'normal' }, props);
    const { id, preview } = useParams();
    const alert = useAlert();
    const [stripeReturn, setStripeReturn] = useState(false);
    const [updateQuote] = useMutation(UpdateDealPublicMutation);
    const [logOpeningDeal] = useMutation(LogOpeningDealMutation);
    // Set primary color from domain
    const domain = useDomain();
    applyBrandColors({
        primary: resolvePrimaryColor(domain.options.color, '#F05B22'),
        accent: domain.options.accentColor,
        surface: domain.options.surfaceColor
    });
    // change favicon with logo
    useEffect(() => {
        var _a, _b;
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
            favicon.href = (_b = (_a = domain.icon) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '/favicon-16x16.png';
        }
    }, [(_a = domain.icon) === null || _a === void 0 ? void 0 : _a.url]);
    // Stripe return
    const queryParameters = new URLSearchParams(window.location.search);
    const session_id = queryParameters.get('session_id');
    const payment_id = queryParameters.get('payment_id');
    const paymentSuccess = queryParameters.get('paymentSuccess');
    if (session_id && !stripeReturn) {
        setStripeReturn(true);
        fetch(process.env.API_URL_ROOT +
            `/stripe-session-status?id=` +
            id +
            `&session_id=${session_id}&payment_id=${payment_id}`, {
            method: 'POST'
        })
            .then((res) => res.json())
            .then((data) => {
            // redirect to the deal
            window.location.href = `/interactive-quote/${id}?paymentSuccess=true`;
        });
    }
    const dealQueryInput = {
        id,
        preview: preview === 'preview' || stripeReturn
    };
    const [data, ready, error] = useQuery(DealPublicQuery, {
        variables: {
            input: dealQueryInput
        },
        fetchPolicy: 'cache-and-network'
    });
    const [fieldGroups] = useQuery(FieldGroupsQuery, {
        variables: {
            input: {
                query: [
                    {
                        field: 'category',
                        operator: 'in',
                        value: ['DEAL', 'DEAL_ITEM', 'DEAL_ITEM_CONFIGURATION']
                    },
                    {
                        field: 'account',
                        operator: 'eq',
                        value: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.account) === null || _d === void 0 ? void 0 : _d.id
                    }
                ]
            }
        },
        fetchPolicy: 'network-only',
        skip: !(data === null || data === void 0 ? void 0 : data.deal)
    });
    const configurationFields = (_f = (_e = data === null || data === void 0 ? void 0 : data.deal) === null || _e === void 0 ? void 0 : _e.configurationFields) !== null && _f !== void 0 ? _f : [];
    const dealItemFields = (_h = (_g = fieldGroups === null || fieldGroups === void 0 ? void 0 : fieldGroups.fieldGroups.filter((fieldGroup) => fieldGroup.category === 'DEAL_ITEM')[0]) === null || _g === void 0 ? void 0 : _g.fields) !== null && _h !== void 0 ? _h : [];
    const dealItemConfigurationFields = (_k = (_j = fieldGroups === null || fieldGroups === void 0 ? void 0 : fieldGroups.fieldGroups.filter((fieldGroup) => fieldGroup.category === 'DEAL_ITEM_CONFIGURATION')[0]) === null || _j === void 0 ? void 0 : _j.fields) !== null && _k !== void 0 ? _k : [];
    const [deal, setDeal] = useState(data === null || data === void 0 ? void 0 : data.deal);
    const [dealTotal, setDealTotal] = useState(0);
    const [dealOtherFees, setDealOtherFees] = useState((_l = data === null || data === void 0 ? void 0 : data.deal) === null || _l === void 0 ? void 0 : _l.otherFees);
    const [processing, setProcessing] = useState(false);
    const [signatureData, setSignatureData] = useState(null);
    const [activityStreamSideBar, setActivityStreamSideBar] = useState(false);
    const [openValidityPeriodModal, setOpenValidityPeriodModal] = useState(false);
    const [validityPeriodDate, setValidityPeriodDate] = useState(null);
    const [openStripeModal, setOpenStripeModal] = useState(false);
    const [openMewsPaymentModal, setOpenMewsPaymentModal] = useState(false);
    const [openPaymentSuccessModal, setOpenPaymentSuccessModal] = useState(false);
    const paymentSuccessHandledRef = useRef(false);
    const priceDisplay = (_m = deal === null || deal === void 0 ? void 0 : deal.priceDisplay) !== null && _m !== void 0 ? _m : 'ALL';
    // Identity verification
    const hasIdentityVerification = (_q = JSON.parse((_p = (_o = configurationFields.find((conf) => conf.fieldKey === 'IDENTITY_VERIFICATION')) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '{}')) === null || _q === void 0 ? void 0 : _q.value;
    // Tracking shares
    const hasTrackingShares = (_t = JSON.parse((_s = (_r = configurationFields.find((conf) => conf.fieldKey === 'TRACKING_SHARES')) === null || _r === void 0 ? void 0 : _r.value) !== null && _s !== void 0 ? _s : '{}')) === null || _t === void 0 ? void 0 : _t.value;
    const [openIdentityVerificationModal, setOpenIdentityVerificationModal] = useState(!preview &&
        (hasIdentityVerification === 'TRUE' || hasTrackingShares === 'TRUE'));
    // Contact fields config (used to determine which fields to show in approval)
    const approvalContactFields = (_x = JSON.parse((_w = (_v = (_u = domain.configurationFields) === null || _u === void 0 ? void 0 : _u.find((conf) => conf.fieldKey === 'DIRECT_SALES_FORM_CONTACT_FIELDS')) === null || _v === void 0 ? void 0 : _v.value) !== null && _w !== void 0 ? _w : '{}')) === null || _x === void 0 ? void 0 : _x.value;
    const hasDeposit = ((_1 = JSON.parse((_0 = (_z = (_y = domain.configurationFields) === null || _y === void 0 ? void 0 : _y.find((conf) => conf.fieldKey === 'HAS_DEPOSIT')) === null || _z === void 0 ? void 0 : _z.value) !== null && _0 !== void 0 ? _0 : '{}')) === null || _1 === void 0 ? void 0 : _1.value) === 'TRUE';
    // Payments
    const hasActivePayments = (_3 = (_2 = deal === null || deal === void 0 ? void 0 : deal.payments) === null || _2 === void 0 ? void 0 : _2.some((payment) => payment.status === 'ACTIVE')) !== null && _3 !== void 0 ? _3 : false;
    const hasActiveDepositPayment = (_5 = (_4 = deal === null || deal === void 0 ? void 0 : deal.payments) === null || _4 === void 0 ? void 0 : _4.some((payment) => payment.status === 'ACTIVE' && payment.isDeposit === true)) !== null && _5 !== void 0 ? _5 : false;
    const isStripePayment = ((_6 = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _6 === void 0 ? void 0 : _6.type) === 'stripe' &&
        !!((_7 = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _7 === void 0 ? void 0 : _7.accountId);
    const isMewsPayment = ((_8 = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _8 === void 0 ? void 0 : _8.type) === 'mews_payment' &&
        !!((_9 = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _9 === void 0 ? void 0 : _9.enterpriseId);
    const hasPaymentIntegration = isStripePayment || isMewsPayment;
    const hasPaymentProcess = hasPaymentIntegration &&
        ((deal === null || deal === void 0 ? void 0 : deal.directSale)
            ? hasActivePayments
            : hasDeposit && hasActiveDepositPayment);
    useEffect(() => {
        document.body.classList.toggle('loaded', ready);
    }, [ready]);
    /**
     * @function isGTMFullyLoaded
     * @since 1.0.0
     * Check if GTM is completely loaded and ready
     */
    function isGTMFullyLoaded() {
        if (typeof window === 'undefined') {
            return false;
        }
        window.dataLayer = window.dataLayer || [];
        // Check if gtm.start is in the dataLayer
        const hasGTMStart = window.dataLayer.some((item) => item['gtm.start'] !== undefined || item.event === 'gtm.js');
        if (!hasGTMStart) {
            return false;
        }
        // Check if google_tag_manager object exists (indicates GTM script is loaded)
        const hasGTMObject = typeof window.google_tag_manager !== 'undefined';
        // Check if GTM script is present in the DOM
        const hasGTMScript = document.querySelector('script[src*="googletagmanager.com/gtm.js"]');
        // GTM is fully loaded if we have gtm.start AND (gtm object OR script in DOM)
        return hasGTMStart && (hasGTMObject || hasGTMScript !== null);
    }
    /**
     * @function buildGTMItems
     * @since 1.0.0
     * Build GTM items array in GA4 format with all required fields
     */
    function buildGTMItems(dealItems, currency, language) {
        return dealItems.map((dealItem) => {
            var _a, _b;
            const saleItem = dealItem.item;
            // Get item name with translation if available
            const itemName = ((_b = (_a = saleItem === null || saleItem === void 0 ? void 0 : saleItem.translations) === null || _a === void 0 ? void 0 : _a.find((translation) => translation.language.code === language)) === null || _b === void 0 ? void 0 : _b.title) ||
                (saleItem === null || saleItem === void 0 ? void 0 : saleItem.title) ||
                '';
            // Get categories from groups (up to 5 levels)
            const categories = [];
            if ((saleItem === null || saleItem === void 0 ? void 0 : saleItem.groups) && saleItem.groups.length > 0) {
                saleItem.groups.slice(0, 5).forEach((group) => {
                    if (group === null || group === void 0 ? void 0 : group.title) {
                        categories.push(group.title);
                    }
                });
            }
            // Fallback to category field if no groups
            if (categories.length === 0 && (saleItem === null || saleItem === void 0 ? void 0 : saleItem.category)) {
                categories.push(saleItem.category);
            }
            // Get variant information
            let itemVariant;
            if (dealItem.variant) {
                itemVariant =
                    dealItem.variant.sku || dealItem.variant.title || undefined;
            }
            // Build the item object
            const gtmItem = {
                currency: (currency === null || currency === void 0 ? void 0 : currency.code) || 'CAD',
                item_id: (saleItem === null || saleItem === void 0 ? void 0 : saleItem.sku) || dealItem.id,
                item_name: itemName,
                price: dealItem.price,
                quantity: dealItem.quantity
            };
            // Add categories
            if (categories.length > 0) {
                gtmItem.item_category = categories[0];
            }
            if (categories.length > 1) {
                gtmItem.item_category2 = categories[1];
            }
            if (categories.length > 2) {
                gtmItem.item_category3 = categories[2];
            }
            if (categories.length > 3) {
                gtmItem.item_category4 = categories[3];
            }
            if (categories.length > 4) {
                gtmItem.item_category5 = categories[4];
            }
            // Add variant if available
            if (itemVariant) {
                gtmItem.item_variant = itemVariant;
            }
            return gtmItem;
        });
    }
    /**
     * @function sendGTMEvent
     * @since 1.0.0
     * Send GTM event with ecommerce data, waiting for GTM to be loaded if necessary
     */
    function sendGTMEvent(eventName, ecommerceData, waitForGTM = true) {
        if (typeof window === 'undefined') {
            return;
        }
        window.dataLayer = window.dataLayer || [];
        const dispatchEvent = () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: eventName, ecommerce: ecommerceData });
        };
        if (!waitForGTM || isGTMFullyLoaded()) {
            dispatchEvent();
            return;
        }
        // Poll until GTM is ready (max 10 seconds)
        const maxRetries = 100;
        let retryCount = 0;
        const checkInterval = setInterval(() => {
            retryCount++;
            if (isGTMFullyLoaded() || retryCount >= maxRetries) {
                clearInterval(checkInterval);
                dispatchEvent();
            }
        }, 100);
    }
    useEffect(() => {
        if (paymentSuccess === 'true' &&
            ready &&
            (data === null || data === void 0 ? void 0 : data.deal) &&
            !paymentSuccessHandledRef.current) {
            paymentSuccessHandledRef.current = true;
            setOpenPaymentSuccessModal(true);
        }
    }, [paymentSuccess, ready, data === null || data === void 0 ? void 0 : data.deal]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        setDeal(data === null || data === void 0 ? void 0 : data.deal);
        if ((_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.language) {
            i18n.changeLanguage(data.deal.language);
        }
        let title = 'Centralio';
        if ((_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.number) {
            title =
                (data.deal.type === 'AGREEMENT' ? t('Agreement #') : t('Quote #')) +
                    ((_c = data === null || data === void 0 ? void 0 : data.deal) === null || _c === void 0 ? void 0 : _c.number) +
                    ' | Centralio';
        }
        document.title = title;
        if (((_d = data === null || data === void 0 ? void 0 : data.deal) === null || _d === void 0 ? void 0 : _d.approbations) && ((_e = data === null || data === void 0 ? void 0 : data.deal) === null || _e === void 0 ? void 0 : _e.approbations.length) > 0) {
            // get last approbation with state ACCEPTED
            const approbations = [...((_g = (_f = data === null || data === void 0 ? void 0 : data.deal) === null || _f === void 0 ? void 0 : _f.approbations) !== null && _g !== void 0 ? _g : [])];
            const approbation = approbations
                .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
                .find((approbation) => approbation.state === 'ACCEPTED');
            if (approbation &&
                (((_h = data.deal) === null || _h === void 0 ? void 0 : _h.status) === 'WON' || ((_j = data.deal) === null || _j === void 0 ? void 0 : _j.status) === 'SIGNED')) {
                setSignatureData({
                    firstName: (_k = approbation.firstName) !== null && _k !== void 0 ? _k : '',
                    lastName: (_l = approbation.lastName) !== null && _l !== void 0 ? _l : '',
                    email: (_m = approbation.email) !== null && _m !== void 0 ? _m : '',
                    date: approbation.date,
                    signatureBase64: (_o = approbation.signatureBase64) !== null && _o !== void 0 ? _o : '',
                    publicUserIp: ''
                });
            }
        }
        if (!preview &&
            (hasIdentityVerification === 'TRUE' || hasTrackingShares === 'TRUE')) {
            setOpenIdentityVerificationModal(true);
        }
    }, [data === null || data === void 0 ? void 0 : data.deal]);
    const quantityType = (_12 = JSON.parse((_11 = (_10 = configurationFields.find((conf) => conf.fieldKey === 'QUANTITY_TYPE')) === null || _10 === void 0 ? void 0 : _10.value) !== null && _11 !== void 0 ? _11 : '{}')) === null || _12 === void 0 ? void 0 : _12.value;
    const hasApproval = (_15 = JSON.parse((_14 = (_13 = configurationFields.find((conf) => conf.fieldKey === 'CLIENT_APPROBATION')) === null || _13 === void 0 ? void 0 : _13.value) !== null && _14 !== void 0 ? _14 : '{}')) === null || _15 === void 0 ? void 0 : _15.value;
    const pricingParameters = (_18 = JSON.parse((_17 = (_16 = configurationFields.find((conf) => conf.fieldKey === 'PRICING_PARAMETERS')) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '{}')) === null || _18 === void 0 ? void 0 : _18.value;
    const hasDealItemConfigurationTime = getConfigurationFieldValue(configurationFields, 'DEAL_ITEM_CONFIGURATION_TIME') === 'TRUE';
    const isAgreement = ((_19 = (deal !== null && deal !== void 0 ? deal : data === null || data === void 0 ? void 0 : data.deal)) === null || _19 === void 0 ? void 0 : _19.type) === 'AGREEMENT';
    const showApproval = hasApproval == 'TRUE' && (isAgreement || priceDisplay !== 'NONE');
    const showContact = !!(((_20 = data === null || data === void 0 ? void 0 : data.deal) === null || _20 === void 0 ? void 0 : _20.contact) || ((_21 = data === null || data === void 0 ? void 0 : data.deal) === null || _21 === void 0 ? void 0 : _21.client));
    const validityPeriodValue = isAgreement
        ? null
        : ((_22 = deal === null || deal === void 0 ? void 0 : deal.validityPeriod) !== null && _22 !== void 0 ? _22 : null);
    useEffect(() => {
        var _a, _b;
        if (validityPeriodValue && !(deal === null || deal === void 0 ? void 0 : deal.directSale) && !isAgreement) {
            // check we are after the validity period
            const validityPeriod = Number(validityPeriodValue);
            const validityPeriodEnd = new Date(Date.parse((_b = (_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.createdAt) !== null && _b !== void 0 ? _b : ''));
            validityPeriodEnd.setDate(validityPeriodEnd.getDate() + validityPeriod);
            const today = new Date();
            setValidityPeriodDate(validityPeriodEnd);
            if (today > validityPeriodEnd) {
                setOpenValidityPeriodModal(true);
            }
        }
    }, [validityPeriodValue]);
    const discountRep = getDiscountRep((_23 = data === null || data === void 0 ? void 0 : data.deal) === null || _23 === void 0 ? void 0 : _23.contact, (_24 = data === null || data === void 0 ? void 0 : data.deal) === null || _24 === void 0 ? void 0 : _24.client);
    /**
     * @function onProcess
     * @since 1.0.0
     * @hidden
     */
    function onProcess(values) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        const id = (_a = data === null || data === void 0 ? void 0 : data.deal) === null || _a === void 0 ? void 0 : _a.id;
        setProcessing(true);
        const isEstrimontOrAxhotel = domain.host === 'estrimont.centralio.com' ||
            domain.host === 'axhotel.centralio.com';
        const firstName = isEstrimontOrAxhotel && ((_b = data === null || data === void 0 ? void 0 : data.deal) === null || _b === void 0 ? void 0 : _b.directSale)
            ? ((_d = (_c = values.firstName) !== null && _c !== void 0 ? _c : signatureData === null || signatureData === void 0 ? void 0 : signatureData.firstName) !== null && _d !== void 0 ? _d : (_f = (_e = data === null || data === void 0 ? void 0 : data.deal) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.firstname)
            : ((_g = signatureData === null || signatureData === void 0 ? void 0 : signatureData.firstName) !== null && _g !== void 0 ? _g : (_j = (_h = data === null || data === void 0 ? void 0 : data.deal) === null || _h === void 0 ? void 0 : _h.contact) === null || _j === void 0 ? void 0 : _j.firstname);
        const lastName = isEstrimontOrAxhotel && ((_k = data === null || data === void 0 ? void 0 : data.deal) === null || _k === void 0 ? void 0 : _k.directSale)
            ? ((_m = (_l = values.lastName) !== null && _l !== void 0 ? _l : signatureData === null || signatureData === void 0 ? void 0 : signatureData.lastName) !== null && _m !== void 0 ? _m : (_p = (_o = data === null || data === void 0 ? void 0 : data.deal) === null || _o === void 0 ? void 0 : _o.contact) === null || _p === void 0 ? void 0 : _p.lastname)
            : ((_q = signatureData === null || signatureData === void 0 ? void 0 : signatureData.lastName) !== null && _q !== void 0 ? _q : (_s = (_r = data === null || data === void 0 ? void 0 : data.deal) === null || _r === void 0 ? void 0 : _r.contact) === null || _s === void 0 ? void 0 : _s.lastname);
        const email = isEstrimontOrAxhotel && ((_t = data === null || data === void 0 ? void 0 : data.deal) === null || _t === void 0 ? void 0 : _t.directSale)
            ? ((_v = (_u = values.approvalEmail) !== null && _u !== void 0 ? _u : signatureData === null || signatureData === void 0 ? void 0 : signatureData.email) !== null && _v !== void 0 ? _v : (_y = (_x = (_w = data === null || data === void 0 ? void 0 : data.deal) === null || _w === void 0 ? void 0 : _w.contact) === null || _x === void 0 ? void 0 : _x.primaryEmail) === null || _y === void 0 ? void 0 : _y.email)
            : ((_z = signatureData === null || signatureData === void 0 ? void 0 : signatureData.email) !== null && _z !== void 0 ? _z : (_2 = (_1 = (_0 = data === null || data === void 0 ? void 0 : data.deal) === null || _0 === void 0 ? void 0 : _0.contact) === null || _1 === void 0 ? void 0 : _1.primaryEmail) === null || _2 === void 0 ? void 0 : _2.email);
        const dealCanBeSigned = ((_3 = data === null || data === void 0 ? void 0 : data.deal) === null || _3 === void 0 ? void 0 : _3.type) === 'AGREEMENT' || ((_5 = (_4 = data === null || data === void 0 ? void 0 : data.deal) === null || _4 === void 0 ? void 0 : _4.canBeSigned) !== null && _5 !== void 0 ? _5 : true);
        const isDirectSaleFlow = !!((_6 = data === null || data === void 0 ? void 0 : data.deal) === null || _6 === void 0 ? void 0 : _6.directSale);
        return {
            variables: {
                input: {
                    id,
                    firstName,
                    lastName,
                    email,
                    date: (_7 = signatureData === null || signatureData === void 0 ? void 0 : signatureData.date) !== null && _7 !== void 0 ? _7 : (_8 = data === null || data === void 0 ? void 0 : data.deal) === null || _8 === void 0 ? void 0 : _8.date,
                    signatureBase64: isDirectSaleFlow
                        ? 'direct-sale'
                        : dealCanBeSigned
                            ? ((_9 = signatureData === null || signatureData === void 0 ? void 0 : signatureData.signatureBase64) !== null && _9 !== void 0 ? _9 : '')
                            : '',
                    publicUserIp: '1.1.1.1',
                    directSale: isDirectSaleFlow
                }
            },
            refetchQueries: [
                {
                    query: DealPublicQuery,
                    variables: {
                        input: {
                            id,
                            directSale: (_10 = data === null || data === void 0 ? void 0 : data.deal) === null || _10 === void 0 ? void 0 : _10.directSale,
                            skipNotification: true
                        }
                    }
                }
            ],
            update(cache) {
                cache.evict({ fieldName: 'deal' });
            }
        };
    }
    /**
     * @function onSuccess
     * @since 1.0.0
     *
     * @hidden
     */
    const onSuccess = () => {
        var _a, _b, _c, _d;
        setProcessing(false);
        if (hasPaymentProcess && deal) {
            // Send begin_checkout event before opening payment modal
            if (domain.options.gtmId && typeof window !== 'undefined') {
                const gtmItems = buildGTMItems(deal.items || [], deal.currency, deal.language || i18n.language);
                sendGTMEvent('begin_checkout', {
                    value: deal.total || deal.subtotal || 0,
                    currency: ((_a = deal.currency) === null || _a === void 0 ? void 0 : _a.code) || 'CAD',
                    items: gtmItems
                }, true);
            }
            if (isMewsPayment) {
                setOpenMewsPaymentModal(true);
            }
            else {
                setOpenStripeModal(true);
            }
        }
        else {
            alert.present({
                title: React.createElement("p", null, t('The quote was approved with success.'))
            });
            // Send quote_acceptance event to GTM
            if (deal && domain.options.gtmId && typeof window !== 'undefined') {
                pushEnhancedConversionUserData(domain.host, {
                    email: (_c = (_b = deal.contact) === null || _b === void 0 ? void 0 : _b.primaryEmail) === null || _c === void 0 ? void 0 : _c.email
                });
                const gtmItems = buildGTMItems(deal.items || [], deal.currency, deal.language || i18n.language);
                sendGTMEvent('quote_acceptance', {
                    transaction_id: deal.id,
                    value: deal.total || deal.subtotal || 0,
                    currency: ((_d = deal.currency) === null || _d === void 0 ? void 0 : _d.code) || 'CAD',
                    items: gtmItems
                }, true);
            }
        }
    };
    /**
     * @function onFailure
     * @since 1.0.0
     * @hidden
     */
    const onFailure = (error) => {
        setProcessing(false);
        alert.present({ error });
    };
    /**
     * @function onDiscuss
     * @since 1.0.0
     * @hidden
     */
    const onDiscuss = () => {
        setActivityStreamSideBar(true);
    };
    /**
     * @function onApprove
     * @since 1.0.0
     * @hidden
     */
    function onApprove() {
        const element = document.getElementById('approval');
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
    const modal = useModal();
    /**
     * @function updateDealField
     * @since 1.0.0
     * @hidden
     */
    const updateDealField = (fieldKey, value, type) => {
        const castedValue = type == 'number' ? Number(value) : value;
        setDeal((prevState) => {
            if (prevState == null) {
                return undefined;
            }
            saveQuote(Object.assign(Object.assign({}, prevState), { [fieldKey]: castedValue }));
            return Object.assign(Object.assign({}, prevState), { [fieldKey]: castedValue });
        });
    };
    /**
     * @function proposeOptionQuote
     * @since 1.0.0
     */
    const proposeOptionQuote = (dealItem, configuration) => {
        var _a, _b, _c, _d, _e, _f;
        if (!deal) {
            return;
        }
        const dealItemIndex = deal.items.findIndex((item) => item.id === dealItem.id);
        if (dealItemIndex === -1) {
            return;
        }
        const currentOptions = (_b = (_a = deal.items[dealItemIndex].options) !== null && _a !== void 0 ? _a : dealItem.options) !== null && _b !== void 0 ? _b : [];
        const options = [];
        // check if it's an alternative to another option
        const alternativeTo = currentOptions.find((entry) => { var _a; return entry.alternativeTo == ((_a = configuration.item) === null || _a === void 0 ? void 0 : _a.id); });
        // Collect restricted group IDs from the option being proposed
        const restrictedGroupIds = new Set();
        if ((_c = configuration.item) === null || _c === void 0 ? void 0 : _c.groups) {
            for (const group of configuration.item.groups) {
                if (group.hasUniqueOptionRestriction) {
                    restrictedGroupIds.add(group.id);
                }
            }
        }
        // Track which restricted groups have already had one option restored
        const restoredGroupIds = new Set();
        const matchesConfiguration = (option) => {
            var _a, _b, _c;
            return (configuration.id && option.id === configuration.id) ||
                (((_a = configuration.item) === null || _a === void 0 ? void 0 : _a.id) && ((_b = option.item) === null || _b === void 0 ? void 0 : _b.id) === ((_c = configuration.item) === null || _c === void 0 ? void 0 : _c.id));
        };
        for (const option of currentOptions) {
            const { item } = option;
            if (matchesConfiguration(option)) {
                options.push(Object.assign(Object.assign({}, option), { proposed: true, alternativeTo: alternativeTo ? (_d = alternativeTo.item) === null || _d === void 0 ? void 0 : _d.id : null }));
            }
            else if (alternativeTo && (item === null || item === void 0 ? void 0 : item.id) == ((_e = alternativeTo.item) === null || _e === void 0 ? void 0 : _e.id)) {
                options.push(Object.assign(Object.assign({}, option), { proposed: false, alternativeTo: null }));
            }
            else {
                // Check if this proposed option should be restored due to restricted group
                let shouldRestore = false;
                if (restrictedGroupIds.size > 0 && option.proposed && (item === null || item === void 0 ? void 0 : item.groups)) {
                    for (const group of item.groups) {
                        if (restrictedGroupIds.has(group.id) &&
                            !restoredGroupIds.has(group.id)) {
                            shouldRestore = true;
                            restoredGroupIds.add(group.id);
                            break;
                        }
                    }
                }
                options.push(Object.assign(Object.assign({}, option), { proposed: shouldRestore ? false : option.proposed }));
            }
        }
        const optionNeedToBeReincluded = dealItem.item.options.find((option) => {
            var _a;
            return (_a = option.relations) === null || _a === void 0 ? void 0 : _a.find((relation) => {
                var _a;
                return relation.type == 'INCOMPATIBLE' &&
                    relation.relatedSaleItem.id == ((_a = configuration.item) === null || _a === void 0 ? void 0 : _a.id);
            });
        });
        if (optionNeedToBeReincluded) {
            options.push(Object.assign(Object.assign({}, optionNeedToBeReincluded), { id: uuidv4(), price: calculatePriceCurrency((_f = optionNeedToBeReincluded.price) !== null && _f !== void 0 ? _f : 0, deal.currency), quantity: optionNeedToBeReincluded.quantity, type: 'OPTION', priceDisplay: 'AMOUNT', hide: false, createdAt: optionNeedToBeReincluded.item.createdAt, updatedAt: optionNeedToBeReincluded.item.updatedAt }));
        }
        const tempDealItems = [...deal.items];
        tempDealItems[dealItemIndex] = Object.assign(Object.assign({}, tempDealItems[dealItemIndex]), { options });
        const updatedDeal = Object.assign(Object.assign({}, deal), { items: tempDealItems });
        setDeal(updatedDeal);
        saveQuote(updatedDeal);
    };
    /**
     * @function includePackageQuote
     * @since 1.0.0
     */
    const includePackageQuote = (dealItem, configuration) => __awaiter(this, void 0, void 0, function* () {
        var _29, _30;
        const packages = [];
        const tempDealItems = deal ? [...deal.items] : [];
        const dealItemIndex = tempDealItems.findIndex((item) => item.id === dealItem.id);
        // Use packages from the current deal state, not from the parameter
        const currentPackages = dealItemIndex > -1 && tempDealItems[dealItemIndex].packages
            ? tempDealItems[dealItemIndex].packages
            : dealItem.packages;
        for (const pack of currentPackages !== null && currentPackages !== void 0 ? currentPackages : []) {
            if (pack.package == null) {
                continue;
            }
            if (pack.package.id == ((_29 = configuration.package) === null || _29 === void 0 ? void 0 : _29.id)) {
                packages.push(Object.assign(Object.assign({}, pack), { proposed: false, initiallyProposed: true, alternativeTo: null }));
            }
            else {
                packages.push(pack);
            }
        }
        // If it's an alternative, we need to make original package proposed
        if (configuration.alternativeTo) {
            const originalPackage = currentPackages === null || currentPackages === void 0 ? void 0 : currentPackages.find((entry) => { var _a; return ((_a = entry.package) === null || _a === void 0 ? void 0 : _a.id) == configuration.alternativeTo; });
            if (originalPackage) {
                const index = packages.findIndex((entry) => { var _a; return ((_a = entry.package) === null || _a === void 0 ? void 0 : _a.id) == configuration.alternativeTo; });
                packages.splice(index, 1);
                packages.push(Object.assign(Object.assign({}, originalPackage), { proposed: true, alternativeTo: (_30 = configuration.package) === null || _30 === void 0 ? void 0 : _30.id }));
            }
        }
        if (dealItemIndex > -1) {
            tempDealItems[dealItemIndex] = Object.assign(Object.assign({}, tempDealItems[dealItemIndex]), { packages });
            if (deal) {
                setDeal(Object.assign(Object.assign({}, deal), { items: tempDealItems }));
                saveQuote(Object.assign(Object.assign({}, deal), { items: tempDealItems }));
            }
        }
    });
    /**
     * @function proposePackageQuote
     * @since 1.0.0
     */
    const proposePackageQuote = (dealItem, configuration) => {
        var _a, _b, _c;
        const packages = [];
        if (!deal) {
            return;
        }
        const tempDealItems = [...deal.items];
        const dealItemIndex = tempDealItems.findIndex((item) => item.id === dealItem.id);
        // Use packages from the current deal state, not from the parameter
        const currentPackages = dealItemIndex > -1 && tempDealItems[dealItemIndex].packages
            ? tempDealItems[dealItemIndex].packages
            : dealItem.packages;
        if (currentPackages) {
            // check if it's an alternative to another package
            const alternativeTo = currentPackages.find((entry) => { var _a; return entry.alternativeTo == ((_a = configuration.package) === null || _a === void 0 ? void 0 : _a.id); });
            for (const pack of currentPackages) {
                if (pack.package == null) {
                    continue;
                }
                if (pack.package.id == ((_a = configuration.package) === null || _a === void 0 ? void 0 : _a.id)) {
                    packages.push(Object.assign(Object.assign({}, pack), { proposed: true, alternativeTo: alternativeTo ? (_b = alternativeTo.package) === null || _b === void 0 ? void 0 : _b.id : null }));
                }
                else if (alternativeTo &&
                    pack.package.id == ((_c = alternativeTo.package) === null || _c === void 0 ? void 0 : _c.id)) {
                    packages.push(Object.assign(Object.assign({}, pack), { proposed: false, alternativeTo: null }));
                }
                else {
                    packages.push(pack);
                }
            }
        }
        if (dealItemIndex > -1) {
            tempDealItems[dealItemIndex] = Object.assign(Object.assign({}, tempDealItems[dealItemIndex]), { packages });
            if (deal) {
                setDeal(Object.assign(Object.assign({}, deal), { items: tempDealItems }));
                saveQuote(Object.assign(Object.assign({}, deal), { items: tempDealItems }));
            }
        }
    };
    /**
     * @function includeOptionQuote
     * @since 1.0.0
     */
    const includeOptionQuote = (dealItem, configuration, newOption = false) => __awaiter(this, void 0, void 0, function* () {
        var _31, _32, _33, _34, _35;
        const options = [];
        const itemsToDelete = [];
        // Map to store quantity increments for options that exist in currentOptions
        // Key: option item ID, Value: quantity to add
        const quantityUpdates = new Map();
        const tempDealItems = deal ? [...deal.items] : [];
        const dealItemIndex = tempDealItems.findIndex((item) => item.id === dealItem.id);
        // Get relations for the option
        const relations = getRelations(dealItem.item, dealItem.variant, configuration.item, dealItemIndex > -1
            ? tempDealItems[dealItemIndex].options
            : dealItem.options, true);
        // Use options from the current deal state, not from the parameter
        const currentOptions = dealItemIndex > -1 && tempDealItems[dealItemIndex].options
            ? tempDealItems[dealItemIndex].options
            : dealItem.options;
        // Check if the configuration item belongs to a group with unique option restriction
        const restrictedGroupIds = new Set();
        if ((_31 = configuration.item) === null || _31 === void 0 ? void 0 : _31.groups) {
            for (const group of configuration.item.groups) {
                if (group.hasUniqueOptionRestriction) {
                    restrictedGroupIds.add(group.id);
                }
            }
        }
        if (currentOptions) {
            for (const option of currentOptions) {
                const { item } = option;
                if (item == null) {
                    continue;
                }
                // Check if this option shares a restricted group with the configuration being included
                let shouldPropose = false;
                if (restrictedGroupIds.size > 0 && item.id !== ((_32 = configuration.item) === null || _32 === void 0 ? void 0 : _32.id)) {
                    if (item.groups) {
                        for (const group of item.groups) {
                            if (restrictedGroupIds.has(group.id)) {
                                shouldPropose = true;
                                break;
                            }
                        }
                    }
                }
                if (item.id == ((_33 = configuration.item) === null || _33 === void 0 ? void 0 : _33.id)) {
                    if (relations.length > 0 && configuration.item) {
                        const isAccepted = yield editConfiguration(configuration.item, relations);
                        if (isAccepted) {
                            options.push(Object.assign(Object.assign({}, option), { proposed: false }));
                            for (const relation of relations) {
                                if (relation.type == 'CONDITIONAL') {
                                    const targetId = String(((_34 = relation.relatedSaleItem) === null || _34 === void 0 ? void 0 : _34.id) || '').trim();
                                    if (!targetId)
                                        continue;
                                    // Check if it exists in currentOptions (to avoid duplicates)
                                    const existsInCurrentOptions = currentOptions.some((opt) => { var _a; return ((_a = opt.item) === null || _a === void 0 ? void 0 : _a.id) && String(opt.item.id).trim() === targetId; });
                                    // Check if it's already in the options array we're building
                                    const existingOptionIndex = options.findIndex((option) => {
                                        if (!option.item || !option.item.id) {
                                            return false;
                                        }
                                        const optionId = String(option.item.id).trim();
                                        return optionId === targetId && optionId !== '';
                                    });
                                    if (existingOptionIndex !== -1) {
                                        // Option already in options array, update quantity
                                        const existingOption = Object.assign({}, options[existingOptionIndex]);
                                        // If option is proposed, replace quantity with relation quantity
                                        // Otherwise, add to existing quantity
                                        const relationQuantity = dealItem.quantity * relation.quantity;
                                        existingOption.quantity = existingOption.proposed
                                            ? relationQuantity
                                            : existingOption.quantity + relationQuantity;
                                        existingOption.proposed = false;
                                        options[existingOptionIndex] = existingOption;
                                    }
                                    else if (existsInCurrentOptions) {
                                        // Option exists in currentOptions but not yet processed
                                        // Store the quantity update to apply when we process it in the main loop
                                        const currentQuantity = quantityUpdates.get(targetId) || 0;
                                        quantityUpdates.set(targetId, currentQuantity + dealItem.quantity * relation.quantity);
                                    }
                                    else {
                                        // Option doesn't exist at all, create new one
                                        options.push({
                                            id: '',
                                            item: relation.relatedSaleItem,
                                            proposed: false,
                                            quantity: dealItem.quantity * relation.quantity,
                                            price: relation.relatedSaleItem.price || 0,
                                            priceDisplay: configuration.priceDisplay,
                                            hide: configuration.hide,
                                            type: relation.type,
                                            createdAt: undefined,
                                            updatedAt: undefined
                                        });
                                    }
                                }
                                else if (relation.type == 'INCOMPATIBLE') {
                                    itemsToDelete.push(relation.relatedSaleItem);
                                }
                            }
                        }
                        else {
                            options.push(Object.assign(Object.assign({}, option), { proposed: true }));
                        }
                    }
                    else {
                        options.push(Object.assign(Object.assign({}, option), { proposed: false, initiallyProposed: true, alternativeTo: null }));
                    }
                }
                else {
                    // Check if this option needs a quantity update
                    const optionId = String(item.id).trim();
                    const quantityToAdd = quantityUpdates.get(optionId);
                    if (quantityToAdd) {
                        // Apply quantity update and mark as not proposed
                        // If option is proposed, replace quantity with relation quantity
                        // Otherwise, add to existing quantity
                        const newQuantity = option.proposed
                            ? quantityToAdd
                            : option.quantity + quantityToAdd;
                        options.push(Object.assign(Object.assign({}, option), { proposed: shouldPropose || false, quantity: newQuantity }));
                        // Remove from map to avoid applying it again
                        quantityUpdates.delete(optionId);
                    }
                    else {
                        options.push(Object.assign(Object.assign({}, option), { proposed: shouldPropose || option.proposed }));
                    }
                }
            }
        }
        // Add new option
        if (newOption) {
            if ((currentOptions === null || currentOptions === void 0 ? void 0 : currentOptions.find((entry) => { var _a, _b; return ((_a = entry.item) === null || _a === void 0 ? void 0 : _a.id) == ((_b = configuration.item) === null || _b === void 0 ? void 0 : _b.id); })) == null) {
                options.push(configuration);
            }
        }
        // Delete incompatible items
        if (itemsToDelete.length > 0) {
            for (const item of itemsToDelete) {
                const index = options.findIndex((entry) => { var _a; return ((_a = entry.item) === null || _a === void 0 ? void 0 : _a.id) == item.id; });
                if (index > -1) {
                    options.splice(index, 1);
                }
            }
        }
        // If it's an alternative, we need to make original option proposed
        if (configuration.alternativeTo) {
            const originalOption = currentOptions === null || currentOptions === void 0 ? void 0 : currentOptions.find((entry) => { var _a; return ((_a = entry.item) === null || _a === void 0 ? void 0 : _a.id) == configuration.alternativeTo; });
            if (originalOption) {
                const index = options.findIndex((entry) => { var _a; return ((_a = entry.item) === null || _a === void 0 ? void 0 : _a.id) == configuration.alternativeTo; });
                options.splice(index, 1);
                options.push(Object.assign(Object.assign({}, originalOption), { proposed: true, alternativeTo: (_35 = configuration.item) === null || _35 === void 0 ? void 0 : _35.id }));
            }
        }
        if (dealItemIndex > -1) {
            tempDealItems[dealItemIndex] = Object.assign(Object.assign({}, tempDealItems[dealItemIndex]), { options });
            if (deal) {
                setDeal(Object.assign(Object.assign({}, deal), { items: tempDealItems }));
                saveQuote(Object.assign(Object.assign({}, deal), { items: tempDealItems }));
            }
        }
    });
    /**
     * @function updateDealOtherFees
     * @since 1.0.0
     */
    const updateDealOtherFees = (otherFees) => {
        setDealOtherFees(otherFees);
        if (deal) {
            setDeal(Object.assign(Object.assign({}, deal), { otherFees }));
        }
    };
    /**
     * @function onItemQuantityChange
     * @since 1.0.0
     */
    const onItemQuantityChange = (dealItem, quantity, applyToAll) => {
        var _a, _b;
        if (!deal)
            return;
        const index = deal.items.findIndex((entry) => entry.id == dealItem.id);
        if (index === -1 || quantity < 1) {
            return;
        }
        const tempDealItems = [...deal.items];
        let tempDealItem = tempDealItems[index];
        const oldQuantity = tempDealItem.quantity || 1;
        const tempOptions = [];
        const tempPackages = [];
        for (const option of (_a = tempDealItem.options) !== null && _a !== void 0 ? _a : []) {
            const quantityPerUnit = option.quantity / oldQuantity;
            tempOptions.push(Object.assign(Object.assign({}, option), { quantity: quantityPerUnit * quantity }));
        }
        for (const pack of (_b = tempDealItem.packages) !== null && _b !== void 0 ? _b : []) {
            const quantityPerUnit = pack.quantity / oldQuantity;
            tempPackages.push(Object.assign(Object.assign({}, pack), { quantity: quantityPerUnit * quantity }));
        }
        tempDealItem = Object.assign(Object.assign({}, tempDealItem), { quantity, options: quantityType === 'GLOBAL' || applyToAll
                ? tempOptions
                : tempDealItem.options, packages: quantityType === 'GLOBAL' || applyToAll
                ? tempPackages
                : tempDealItem.packages });
        tempDealItems[index] = tempDealItem;
        const updatedDeal = Object.assign(Object.assign({}, deal), { items: tempDealItems });
        setDeal(updatedDeal);
        saveQuote(updatedDeal);
    };
    /**
     * @function onOptionQuantityChange
     * @since 1.0.0
     */
    const onOptionQuantityChange = (dealItem, option, quantity) => {
        if (!deal)
            return;
        const updatedDeal = Object.assign(Object.assign({}, deal), { items: deal.items.map((item) => {
                var _a, _b;
                return item.id === dealItem.id
                    ? Object.assign(Object.assign({}, item), { options: (_b = (_a = item.options) === null || _a === void 0 ? void 0 : _a.map((opt) => opt.id === option.id
                            ? Object.assign(Object.assign({}, opt), { quantity }) : opt)) !== null && _b !== void 0 ? _b : [] }) : item;
            }) });
        setDeal(updatedDeal);
        saveQuote(updatedDeal);
    };
    /**
     * @function onPackageQuantityChange
     * @since 1.0.0
     */
    const onPackageQuantityChange = (dealItem, pack, quantity) => {
        if (!deal)
            return;
        const updatedDeal = Object.assign(Object.assign({}, deal), { items: deal.items.map((item) => {
                var _a, _b;
                return item.id === dealItem.id
                    ? Object.assign(Object.assign({}, item), { packages: (_b = (_a = item.packages) === null || _a === void 0 ? void 0 : _a.map((p) => p.id === pack.id
                            ? Object.assign(Object.assign({}, p), { quantity }) : p)) !== null && _b !== void 0 ? _b : [] }) : item;
            }) });
        setDeal(updatedDeal);
        saveQuote(updatedDeal);
    };
    /**
     * @function saveQuote
     * @since 1.0.0
     **/
    const saveQuote = (updatedDeal) => __awaiter(this, void 0, void 0, function* () {
        var _36;
        if (updatedDeal.status !== 'WIN' && updatedDeal.status !== 'LOST') {
            const recalculatedOtherFees = recalculateOtherFeesPrices(updatedDeal);
            const input = {
                id: updatedDeal === null || updatedDeal === void 0 ? void 0 : updatedDeal.id,
                items: toUpdateDealItemInput((_36 = updatedDeal === null || updatedDeal === void 0 ? void 0 : updatedDeal.items) !== null && _36 !== void 0 ? _36 : []),
                otherFees: recalculatedOtherFees.map((fee) => {
                    var _a;
                    return ({
                        fee: (_a = fee.fee) === null || _a === void 0 ? void 0 : _a.id,
                        description: fee.description,
                        price: fee.price
                    });
                }),
                discountType: updatedDeal.discountType
            };
            try {
                yield updateQuote({
                    variables: {
                        input
                    },
                    refetchQueries: [
                        {
                            query: DealPublicQuery,
                            variables: {
                                input: dealQueryInput
                            }
                        }
                    ]
                });
                if (updatedDeal.language) {
                    i18n.changeLanguage(updatedDeal.language);
                }
                alert.present({
                    title: React.createElement("p", null, (deal === null || deal === void 0 ? void 0 : deal.directSale) ? t('Order saved') : t('Quote saved'))
                });
            }
            catch (error) {
                alert.present({
                    title: (React.createElement("p", null, (deal === null || deal === void 0 ? void 0 : deal.directSale)
                        ? t('Order cannot be saved')
                        : t('Quote cannot be saved')))
                });
            }
        }
    });
    /**
     * @function editConfiguration
     * @since 1.0.0
     * @return boolean
     * @hidden
     **/
    function editConfiguration(item, relations) {
        return new Promise((resolve, reject) => {
            const onAccept = () => {
                modal.dismiss();
                resolve(true);
            };
            const onDiscard = () => {
                modal.dismiss();
                resolve(false);
            };
            modal.present({
                style: 'dialog',
                title: t('Edit Configuration'),
                picto: 'check',
                modal: (React.createElement(DealItemPickerOptionAlert, { item: item, relations: relations, onAccept: onAccept, onDiscard: onDiscard }))
            });
        });
    }
    /**
     * @function onCloseModal
     * @since 1.0.0
     * @hidden
     */
    const onCloseModal = (email) => {
        if (openValidityPeriodModal) {
            setOpenValidityPeriodModal(false);
        }
        if (openStripeModal) {
            setOpenStripeModal(false);
        }
        if (openIdentityVerificationModal) {
            setOpenIdentityVerificationModal(false);
            if (deal) {
                logOpeningDeal({
                    variables: {
                        input: {
                            id: deal.id,
                            email
                        }
                    }
                });
            }
        }
    };
    const context = {
        includeOptionQuote,
        includePackageQuote,
        proposeOptionQuote,
        proposePackageQuote,
        pricingParameters,
        quantityType,
        updateDealField,
        configurationFields,
        hasDealItemConfigurationTime,
        deal,
        dealItemFields,
        dealItemConfigurationFields,
        dealTotal,
        setDealTotal,
        updateDealOtherFees,
        onItemQuantityChange,
        onOptionQuantityChange,
        onPackageQuantityChange
    };
    const className = classNames(!activityStreamSideBar
        ? `quote-screen ${(_27 = (_26 = (_25 = data === null || data === void 0 ? void 0 : data.deal) === null || _25 === void 0 ? void 0 : _25.user) === null || _26 === void 0 ? void 0 : _26.account) === null || _27 === void 0 ? void 0 : _27.tag}`
        : 'quote-screen-activity-stream', { 'quote-screen--blured': openIdentityVerificationModal });
    if (error) {
        return (React.createElement(Error, { title: t('Unavailable Quote'), infos: t('The quote you are looking for is not available.'), picto: "fal triangle-exclamation", error: error }));
    }
    return (React.createElement(QuoteContext.Provider, { value: context },
        React.createElement(Screen, { className: className, ready: ready || !!(data === null || data === void 0 ? void 0 : data.deal), error: error },
            React.createElement(MutationForm, { name: "approve-deal", mutation: ApproveDealMutation, onProcess: onProcess, onSuccess: onSuccess, onFailure: onFailure },
                React.createElement(Header, null, (deal !== null && deal !== void 0 ? deal : data === null || data === void 0 ? void 0 : data.deal) && (React.createElement(QuoteHeader, { data: (deal !== null && deal !== void 0 ? deal : data.deal), hasApproval: hasApproval, hasPaymentProcess: !isAgreement && !!hasPaymentProcess, hasDeposit: hasDeposit && !((_28 = (deal !== null && deal !== void 0 ? deal : data === null || data === void 0 ? void 0 : data.deal)) === null || _28 === void 0 ? void 0 : _28.directSale), onApprove: onApprove, onDiscuss: onDiscuss }))),
                React.createElement("div", { className: "quote-header-infos--mobile" },
                    React.createElement(QuoteHeaderInfo, { data: deal !== null && deal !== void 0 ? deal : data === null || data === void 0 ? void 0 : data.deal, onApprove: onApprove })),
                React.createElement(Content, null,
                    deal && (React.createElement(Fragment, null,
                        React.createElement(QuoteBanner, { data: deal, configurationFields: configurationFields }),
                        React.createElement(QuoteClient, { data: deal, configurationFields: configurationFields }),
                        React.createElement(QuoteField, { data: deal }),
                        priceDisplay === 'BUNDLED' && !isAgreement ? (React.createElement(QuoteSummaryBundled, { data: deal, discountRep: discountRep, configurationFields: configurationFields })) : (React.createElement(QuoteSummary, { data: isAgreement ? Object.assign(Object.assign({}, deal), { priceDisplay: 'NONE' }) : deal, discountRep: discountRep, configurationFields: configurationFields })),
                        !isAgreement &&
                            (priceDisplay === 'ALL' ||
                                priceDisplay === 'BUNDLED' ||
                                priceDisplay === 'TOTAL') && (React.createElement("div", { id: "budget", className: "quote-section quote-summary" },
                            React.createElement(QuoteSummaryPanel, { deal: deal, staticMode: true }))),
                        React.createElement(QuoteNotes, { data: deal }),
                        (showContact || showApproval) && (React.createElement("div", { className: "quote-screen-approval" },
                            showContact && React.createElement(QuoteContact, { data: data === null || data === void 0 ? void 0 : data.deal }),
                            showApproval && (React.createElement(QuoteApproval, { data: deal, openStripeModal: openStripeModal, openMewsPaymentModal: openMewsPaymentModal, processing: processing, setSignatureData: setSignatureData, signatureData: signatureData, validityPeriodDate: isAgreement ? null : validityPeriodDate, hasPaymentProcess: !isAgreement && !!hasPaymentProcess, hasDeposit: hasDeposit && !(deal === null || deal === void 0 ? void 0 : deal.directSale), host: domain.host, contactFields: approvalContactFields })))))),
                    React.createElement("div", { className: "quote-screen-powered" },
                        React.createElement("div", { className: "quote-screen-powered-text" }, isAgreement ? t('Powered by') : t('Interactive Quote™ by')),
                        React.createElement("div", { className: "quote-screen-powered-logo" },
                            React.createElement("a", { href: "https://centralio.com", target: "_blank", rel: "noreferrer" },
                                React.createElement("img", { src: "/images/icon.svg" }),
                                React.createElement("span", { className: "quote-screen-powered-centralio" }, "Centralio")))))),
            activityStreamSideBar && (React.createElement(Sidebar, null, deal && (React.createElement(DealSidebar, { deal: deal, setActivityStreamSideBar: setActivityStreamSideBar, isQuote: true, activityStreamEntityType: "CHAT" })))),
            openValidityPeriodModal && (React.createElement(ModalValidityPeriod, { deal: deal, validityPeriodDate: validityPeriodDate, onClose: onCloseModal, onDiscuss: onDiscuss })),
            openIdentityVerificationModal && (React.createElement(ModalIdentityVerification, { deal: deal, hasIdentityVerification: hasIdentityVerification === 'TRUE', hasTrackingShares: hasTrackingShares === 'TRUE', onClose: onCloseModal })),
            openPaymentSuccessModal && (React.createElement(ModalPaymentSuccess, { deal: deal, onClose: () => setOpenPaymentSuccessModal(false), hasDeposit: hasDeposit })))));
}
/**
 * @component QuoteContext
 * @since 1.0.0
 */
export const QuoteContext = createContext({
    proposeOptionQuote() { },
    proposePackageQuote() { },
    includeOptionQuote() { },
    includePackageQuote() { },
    updateDealField() { },
    updateDealOtherFees() { },
    setDealTotal() { },
    onItemQuantityChange() { },
    onOptionQuantityChange() { },
    onPackageQuantityChange() { },
    deal: undefined,
    dealTotal: 0,
    pricingParameters: 'DISCOUNT',
    quantityType: '',
    configurationFields: [],
    hasDealItemConfigurationTime: false,
    dealItemFields: [],
    dealItemConfigurationFields: []
});
/**
 * @function useQuoteContext
 * @since 1.0.0
 */
export function useQuoteContext() {
    return useContext(QuoteContext);
}
/**
 * @function toUpdateDealItemInput
 * @param source
 * @hidden
 */
const toUpdateDealItemInput = (source) => {
    return source.map((item) => {
        var _a, _b;
        return ({
            id: item.id,
            item: item.item.id,
            quantity: item.quantity,
            price: item.price,
            proposed: (_a = item.proposed) !== null && _a !== void 0 ? _a : false,
            initiallyProposed: (_b = item.initiallyProposed) !== null && _b !== void 0 ? _b : false,
            alternativeTo: item.alternativeTo,
            options: toDealItemInputOptions(item.options),
            packages: toDealItemPackageInput(item.packages)
        });
    });
};
/**
 * @function toDealItemInputOptions
 * @param source
 * @hidden
 */
const toDealItemInputOptions = (source) => {
    if (source == null) {
        return [];
    }
    const result = source.map((entry) => {
        var _a, _b, _c, _d;
        return ({
            item: (_a = entry.item) === null || _a === void 0 ? void 0 : _a.id,
            price: entry.price,
            feeValue: entry.feeValue,
            quantity: entry.quantity,
            proposed: entry.proposed,
            included: entry.included,
            initiallyProposed: entry.initiallyProposed,
            alternativeTo: entry.alternativeTo,
            priceDisplay: entry.priceDisplay,
            startTime: (_b = entry.startTime) !== null && _b !== void 0 ? _b : null,
            endTime: (_c = entry.endTime) !== null && _c !== void 0 ? _c : null,
            fieldValues: (_d = entry.fieldValues) === null || _d === void 0 ? void 0 : _d.map((fieldValue) => {
                var _a;
                return ({
                    fieldId: (_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id,
                    value: JSON.stringify({ value: JSON.parse(fieldValue.value).value })
                });
            })
        });
    });
    return result;
};
/**
 * @function toDealItemPackageInput
 * @param source
 * @hidden
 */
const toDealItemPackageInput = (source) => {
    if (source == null) {
        return [];
    }
    const result = source.map((entry) => {
        var _a, _b, _c, _d;
        return ({
            package: (_a = entry.package) === null || _a === void 0 ? void 0 : _a.id,
            price: entry.price,
            quantity: entry.quantity,
            proposed: entry.proposed,
            initiallyProposed: entry.initiallyProposed,
            alternativeTo: entry.alternativeTo,
            priceDisplay: entry.priceDisplay,
            startTime: (_b = entry.startTime) !== null && _b !== void 0 ? _b : null,
            endTime: (_c = entry.endTime) !== null && _c !== void 0 ? _c : null,
            fieldValues: (_d = entry.fieldValues) === null || _d === void 0 ? void 0 : _d.map((fieldValue) => {
                var _a;
                return ({
                    fieldId: (_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id,
                    value: JSON.stringify({ value: JSON.parse(fieldValue.value).value })
                });
            })
        });
    });
    return result;
};
